/**
 * @generated SignedSource<<64289f346ee2a0194a0429d6fc081742>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type url_nativeIssueTable_UrlCell$data = {
  readonly id: string;
  readonly lazyIsEditableInIssueView?: boolean | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"url_issueFieldUrlInlineEditFull_UrlInlineEditViewIsEditable_fragmentRef">;
  readonly " $fragmentType": "url_nativeIssueTable_UrlCell";
};
export type url_nativeIssueTable_UrlCell$key = {
  readonly " $data"?: url_nativeIssueTable_UrlCell$data;
  readonly " $fragmentSpreads": FragmentRefs<"url_nativeIssueTable_UrlCell">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isInlineEditingEnabled"
    }
  ],
  "kind": "Fragment",
  "name": "url_nativeIssueTable_UrlCell",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "id"
    },
    {
      "condition": "isInlineEditingEnabled",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "ClientExtension",
          "selections": [
            {
              "kind": "ScalarField",
              "name": "lazyIsEditableInIssueView"
            }
          ]
        }
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "url_issueFieldUrlInlineEditFull_UrlInlineEditViewIsEditable_fragmentRef"
    }
  ],
  "type": "JiraUrlField"
};

(node as any).hash = "290582e90638b9296d772bdb0ec42416";

export default node;
